"use strict";

define('evisions/helper/render',['jquery', 'underscore', 'moment', 'evisions/helper/defer', 'evisions/helper/test', 'handlebars'], function ($, _, moment, EVIHelperDefer, EVIHelperTest, handlebars) {
  var templates = {};
  handlebars.registerHelper('dateFormat', function (context, block) {
    if (window.moment) {
      var f = block.hash.format || "MMM DD, YYYY hh:mm:ss A";
      return context ? moment(context).format(f) : context;
    } else {
      return context;
    }
    ;
  });
  var EVIHelperRender = _.extend({
    setupTemplates: function setupTemplates(newTemplates) {
      templates = newTemplates;
    },
    datum: function datum(el, _datum) {
      if (el instanceof $) {
        el = el.get(0);
      }
      if (_datum !== undefined) {
        el.__data__ = _datum;
      }
      return el.__data__;
    },
    destroyScroll: function destroyScroll(el) {
      if (!EVIHelperTest.isTouchDevice() && $.fn.mCustomScrollbar) {
        el.mCustomScrollbar('destroy');
      }
    },
    fastHtmlToDom: function fastHtmlToDom() {
      var htmlBuilder = document.createElement("div");
      return function fastInsert(html) {
        htmlBuilder.innerHTML = html;
        return htmlBuilder.firstChild;
      };
    },
    loadImages: function loadImages(images) {
      images = EVIHelperTest.isArray(images) ? images : [];
      var d = EVIHelperDefer.deferred(),
        index = 0;
      var _load = function load() {
        if (index === images.length) {
          d.resolve();
        } else {
          $(new Image()).attr('src', images[index]).load(_load).error(_load);
          index++;
        }
      };
      _load();
      return d;
    },
    openPopup: function openPopup(location, width, height) {
      var day = new Date(),
        id = day.getTime();
      return window.open(location, id, "toolbar=0,scrollbars=1,location=0,statusbar=0,menubar=0,resizable=1,width=" + width + ",height=" + height);
    },
    parsePositionString: function parsePositionString(position) {
      position = position || 'center';
      var positions = position.split(' '),
        offsetRegExp = /[+-]{1}\d+/,
        positionRegExp = /^\w+/,
        horizontalPositionString = positions[0],
        verticalPositionsString = positions[1] || positions[0],
        horizontalMatch = horizontalPositionString.match(positionRegExp) || '',
        verticalMatch = verticalPositionsString.match(positionRegExp) || '';
      return {
        horizontal: horizontalMatch.toString() || 'center',
        vertical: verticalMatch.toString() || '',
        horizontalOffset: parseInt(horizontalPositionString.match(offsetRegExp), 10) || 0,
        verticalOffset: parseInt(verticalPositionsString.match(offsetRegExp), 10) || 0
      };
    },
    position: function position(o) {
      var of = $(o.of),
        target = o.target;
      if (!of.length) {
        return false;
      }
      if (!target || !target.length) {
        return false;
      }
      var offset = of.offset(),
        ofWidth = of.outerWidth(),
        ofHeight = of.outerHeight(),
        targetWidth = target.outerWidth(),
        targetHeight = target.outerHeight(),
        targetPosition = eviHelperRender.parsePositionString(o.my),
        ofPosition = eviHelperRender.parsePositionString(o.at);
      switch (targetPosition.horizontal) {
        case 'left':
          break;
        case 'right':
          offset.left -= targetWidth;
          break;
        default:
          offset.left -= targetWidth / 2;
          break;
      }
      offset.left += targetPosition.horizontalOffset;
      switch (targetPosition.vertical) {
        case 'top':
          break;
        case 'bottom':
          offset.top -= targetHeight;
          break;
        default:
          offset.top -= targetHeight / 2;
          break;
      }
      offset.top += targetPosition.verticalOffset;
      switch (ofPosition.horizontal) {
        case 'left':
          break;
        case 'right':
          offset.left += ofWidth;
          break;
        default:
          offset.left += ofWidth / 2;
          break;
      }
      offset.left += ofPosition.horizontalOffset;
      switch (ofPosition.vertical) {
        case 'top':
          break;
        case 'bottom':
          offset.top += ofHeight;
          break;
        default:
          offset.top += ofHeight / 2;
          break;
      }
      offset.top += ofPosition.verticalOffset;
      target.offset(offset);
      return true;
    },
    template: function template(name, data, options) {
      var template = templates[name];
      if (template) {
        return template(data || {}, options);
      }
      return '';
    },
    getTemplateByName: function getTemplateByName(name) {
      return templates[name];
    },
    templateExists: function templateExists(name) {
      return !!templates[name];
    },
    setupHTML: function setupHTML() {
      var body = $(document.body);
      if (EVIHelperTest.isTouchDevice()) {
        body.addClass('yes-touch');
      } else {
        body.addClass('no-touch');
      }
    },
    setupScroll: function setupScroll(el, light, callbacks) {
      if (!EVIHelperTest.isTouchDevice() && !EVIHelperTest.isARMDevice() && $.fn.mCustomScrollbar) {
        el.mCustomScrollbar({
          horizontalScroll: false,
          theme: light ? 'light-thick' : 'dark-thick',
          scrollInertia: 0,
          mouseWheel: true,
          mouseWheelPixels: 'auto',
          advanced: {
            scrollSpeed: 'auto',
            updateOnBrowserResize: true
          },
          callbacks: callbacks
        });
      }
    },
    updateScroll: function updateScroll(el) {
      if (!EVIHelperTest.isTouchDevice() && $.fn.mCustomScrollbar) {
        el.mCustomScrollbar('update');
      }
    },
    scrollBarWidth: function scrollBarWidth() {
      if (!EVIHelperRender._scrollBarWidth) {
        var scrollDiv = document.createElement("div");
        scrollDiv.className = "scrollbar-measure";
        $(scrollDiv).css({
          width: '100px',
          height: '100px',
          overflow: 'scroll',
          position: 'absolute',
          top: '-9999px'
        });
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        EVIHelperRender._scrollBarWidth = scrollbarWidth;
      }
      return EVIHelperRender._scrollBarWidth;
    }
  });
  return EVIHelperRender;
});

